import Component from '@glimmer/component';
import { action } from '@ember/object';

import { WrapperScope } from 'mewe/constants';
import dispatcher from 'mewe/dispatcher';

export default class MwWrappersOptions extends Component {
  @action
  dismissAll() {
    dispatcher.dispatch('feed', 'dismissWrappers', {
      all: this.args.scope === WrapperScope.ALL,
      allGroups: this.args.scope === WrapperScope.GROUP,
      allPages: this.args.scope === WrapperScope.PAGE,
    });
  }
}
